<h2 mat-dialog-title>
  <mat-icon color="primary">settings</mat-icon>
  {{ 'FirmwareUpdate.ConfigTitle' | translate }}
</h2>
<mat-dialog-content>
  <!-- Filters row -->
  <div class="filter-row">
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>{{ 'FirmwareUpdate.FilterByCompany' | translate }}</mat-label>
      <input matInput
        [(ngModel)]="companySearchText"
        (ngModelChange)="onCompanySearch($event)"
        [matAutocomplete]="companyAuto">
      <mat-autocomplete #companyAuto="matAutocomplete"
        [displayWith]="displayCompanyName.bind(this)"
        (optionSelected)="onCompanySelected($event)">
        <mat-option *ngFor="let c of filteredCompanies" [value]="c._id">
          {{ c.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" class="half-width" *ngIf="receiverOptions.length > 0">
      <mat-label>{{ 'FirmwareUpdate.FilterByReceptora' | translate }}</mat-label>
      <mat-select [(ngModel)]="selectedApiKey" (selectionChange)="onReceiverSelected()">
        <mat-option *ngFor="let r of receiverOptions" [value]="r.apiKey">
          {{ r.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Config form -->
  <div class="config-form" *ngIf="configLoaded">
    <div class="config-grid">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'FirmwareUpdate.ConfigMaxConcurrent' | translate }}</mat-label>
        <input matInput type="number" [(ngModel)]="config.maxConcurrentDevices" min="1" max="50">
        <mat-hint>{{ 'FirmwareUpdate.ConfigMaxConcurrentHint' | translate }}</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'FirmwareUpdate.ConfigSendInterval' | translate }}</mat-label>
        <input matInput type="number" [(ngModel)]="config.sendIntervalMs" min="50" max="5000">
        <mat-hint>{{ 'FirmwareUpdate.ConfigSendIntervalHint' | translate }}</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'FirmwareUpdate.ConfigDataTimeout' | translate }}</mat-label>
        <input matInput type="number" [(ngModel)]="config.dataTimeoutMs" min="1000" max="30000">
        <mat-hint>{{ 'FirmwareUpdate.ConfigDataTimeoutHint' | translate }}</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'FirmwareUpdate.ConfigMaxRestarts' | translate }}</mat-label>
        <input matInput type="number" [(ngModel)]="config.maxRestartsPerDevice" min="0" max="10">
        <mat-hint>{{ 'FirmwareUpdate.ConfigMaxRestartsHint' | translate }}</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'FirmwareUpdate.ConfigRestartWait' | translate }}</mat-label>
        <input matInput type="number" step="1"
          [(ngModel)]="config.restartWaitSeconds"
          [min]="restartWaitMinSeconds"
          [max]="restartWaitMaxSeconds">
        <mat-hint [class.restart-wait-invalid]="!isRestartWaitValid()">
          {{ 'FirmwareUpdate.ConfigRestartWaitHint' | translate: { min: restartWaitMinSeconds, max: restartWaitMaxSeconds } }}
        </mat-hint>
      </mat-form-field>
    </div>

    <!-- Warning -->
    <div class="config-warning">
      <mat-icon>warning_amber</mat-icon>
      <span>{{ 'FirmwareUpdate.ConfigWarning' | translate }}</span>
    </div>
  </div>

  <div class="no-receiver" *ngIf="!selectedApiKey">
    <mat-icon>info_outline</mat-icon>
    <span>{{ 'FirmwareUpdate.ConfigSelectReceiver' | translate }}</span>
  </div>

  <div class="loading-config" *ngIf="selectedApiKey && !configLoaded && isLoading">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">{{ 'Shared.Cancel' | translate }}</button>
  <button mat-raised-button color="primary"
    [disabled]="!configLoaded || isSaving || !isRestartWaitValid()"
    (click)="saveConfig()">
    <mat-icon>save</mat-icon>
    {{ 'Shared.Save' | translate }}
  </button>
</mat-dialog-actions>
